import { required } from 'vuelidate/lib/validators'

const formData = {
  presentation: {
    type: 'textarea',
    name: 'presentation',
    placeholder: 'Insira um texto de apresentação para exibição no aplicativo',
    classes: ['app-education__form-field--100'],
    display: false,
    required: true,
    value: null
  },

  university: {
    size: 5,
    type: 'text',
    name: 'university',
    label: 'Faculdade',
    placeholder: 'Em qual faculdade se formou?',
    classes: ['app-education__form-field--40'],
    required: true,
    display: true,
    value: null
  },

  universityStartDate: {
    size: 2,
    type: 'text',
    name: 'universityStartDate',
    label: 'Ano de início',
    placeholder: 'Ano de início',
    mask: '####',
    classes: ['app-education__form-field--25'],
    value: null,
    required: true,
    display: true
  },

  universityEndDate: {
    size: 2,
    type: 'text',
    name: 'universityEndDate',
    label: 'Ano de conclusão',
    placeholder: 'Ano de conclusão',
    mask: '####',
    classes: ['app-education__form-field--25'],
    value: null,
    required: true,
    display: true
  },

  isAmbEspecialization: {
    size: 5,
    type: 'radio',
    name: 'isAmbEspecialization',
    label: 'Possui título de especialização pela AMB?',
    classes: ['app-education__form-field--40'],
    value: null,
    required: true,
    display: true,
    radios: [
      {
        name: 'is_amb',
        label: 'Sim',
        value: 1
      },
      {
        name: 'not_amb',
        label: 'Não',
        value: 0
      }
    ]
  },

  specializationCourses: {
    size: 12,
    type: 'array',
    name: 'specializationCourses',
    label: 'Cursos de especialização',
    placeholder: 'Insira o nome do curso',
    classes: ['app-education__form-field--60'],
    value: null,
    display: true
  }
}

const validations = {}

Object.keys(formData)
  .map((key) => {
    if (formData[key].required) {
      validations[key] = {
        value: {
          required
        }
      }
    }
  })

export { formData, validations }
